var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('font-awesome-icon',{style:({ color: 'white' }),attrs:{"icon":_vm.actualIconName,"size":_vm.actualIconSize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }